import { render, staticRenderFns } from "./GuestHistory.vue?vue&type=template&id=504dc224"
import script from "./GuestHistory.vue?vue&type=script&lang=js"
export * from "./GuestHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports